/* Hera theme script. Shared parts (bag, header, announcement) run on every page;
   the storefront parts run only where the Hera section is on the page. */
(function(){
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const H = window.HERA || {variantList:[], assetBase:''};
  const VARIANTS = Array.isArray(H.variantList) ? H.variantList : [];

  const COLORS = {
    pink:{name:'Baby Pink', sw:'#EFCFD3', handle:'baby-pink'},
    blue:{name:'Baby Blue', sw:'#93D0DB', handle:'baby-blue'},
    white:{name:'Pearl White', sw:'#F5F6F5', handle:'pearl-white'},
    black:{name:'Onyx Black', sw:'#2B2B2D', handle:'onyx-black'}
  };
  const byName = name => Object.keys(COLORS).find(k => COLORS[k].name.toLowerCase() === String(name).toLowerCase()) || 'pink';
  // Display prices. The pack prices are produced in Shopify by the two automatic discounts.
  const BUNDLES = {1:{price:229, label:'1 alarm'}, 2:{price:399, label:'2-pack', each:'R200'}, 3:{price:549, label:'3-pack', each:'R183'}};
  const SINGLE = 229, FREE_AT = 350, SHIP = 65;
  const SHORT = {pink:'Pink', blue:'Blue', white:'White', black:'Black'};
  const money = n => 'R' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const cents = c => money(c / 100);
  const pill = c => `<div class="c-${c}"><svg class="pill" viewBox="0 0 200 480" aria-hidden="true"><use href="#hera-pill"/></svg></div>`;
  const esc = s => String(s).replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));

  /* ---------- Toast ---------- */
  let toastTimer = null;
  function toast(text){
    const t = $('#toast'); if (!t) return;
    t.textContent = text; t.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('show'), 3600);
  }

  /* ========== BAG (Shopify cart) ========== */
  let cart = {items:[], item_count:0, total_price:0, items_subtotal_price:0, total_discount:0, note:''};
  const json = {'Content-Type':'application/json', 'Accept':'application/json'};
  async function fetchCart(bump){
    try {
      const r = await fetch('/cart.js', {headers:{Accept:'application/json'}, credentials:'same-origin'});
      cart = await r.json();
    } catch(e){ /* keep last known cart */ }
    renderCart(bump);
  }
  async function cartPost(url, body){
    const r = await fetch(url, {method:'POST', headers:json, credentials:'same-origin', body:JSON.stringify(body)});
    if (!r.ok){
      const e = await r.json().catch(() => ({}));
      throw new Error(e.description || e.message || 'Something went wrong. Please try again.');
    }
    return r.json();
  }
  /* Find the Shopify variant for a color. Forgiving about naming ("Pink", "Baby Pink", "pink alarm")
     and about option order. If the product has a single variant, every color uses it and the
     chosen color is saved on the order line instead. */
  const COLOR_WORDS = {pink:['baby pink','pink'], blue:['baby blue','blue','aqua','turquoise','teal'], white:['pearl white','white'], black:['onyx black','black']};
  const norm = s => String(s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  function variantFor(c){
    const words = COLOR_WORDS[c];
    for (const w of words){ const v = VARIANTS.find(v => (v.options || []).some(o => norm(o) === w)); if (v) return {v, exact:true}; }
    for (const w of words){ const v = VARIANTS.find(v => (v.options || []).some(o => norm(o).includes(w)) || norm(v.title).includes(w)); if (v) return {v, exact:true}; }
    if (VARIANTS.length === 1) return {v:VARIANTS[0], exact:false};
    return null;
  }
  const colorAvailable = c => { const m = variantFor(c); return !!(m && m.v.available); };
  const storeReady = () => VARIANTS.length > 0 && Object.keys(COLORS).some(colorAvailable);

  async function addToCart(colors){
    if (!VARIANTS.length){
      toast('Hera isn’t available to order just yet. Please check back soon.');
      if (H.designMode || /myshopify\.com$/.test(location.hostname)) console.warn('[Hera] No product found. In Shopify admin: set the product to Active and make it available on the Online Store sales channel, then choose it in Customize → Hera storefront → Hera product.');
      return false;
    }
    const lines = {};
    for (const c of colors){
      const m = variantFor(c);
      if (!m){ toast(COLORS[c].name + ' isn’t available right now. Please choose another color.'); return false; }
      if (!m.v.available){ toast(COLORS[c].name + ' is sold out right now. Please choose another color.'); return false; }
      const key = m.exact ? String(m.v.id) : m.v.id + ':' + c;
      if (!lines[key]) lines[key] = {id:m.v.id, quantity:0, ...(m.exact ? {} : {properties:{Color:COLORS[c].name}})};
      lines[key].quantity++;
    }
    try { await cartPost('/cart/add.js', {items:Object.values(lines)}); }
    catch(e){ toast(e.message); return false; }
    await fetchCart(true);
    return true;
  }
  async function changeLine(key, quantity){
    try { await cartPost('/cart/change.js', {id:key, quantity}); } catch(e){ toast(e.message); }
    await fetchCart(quantity > 0);
  }

  function renderCart(bump){
    const n = cart.item_count || 0;
    const cc = $('#cartCount');
    if (cc){
      cc.textContent = n;
      if (bump && !reduce){ cc.classList.remove('bump'); void cc.offsetWidth; cc.classList.add('bump'); }
    }
    const sr = $('#cartSr'); if (sr) sr.textContent = 'Shopping bag, ' + n + (n === 1 ? ' item' : ' items');
    const lines = $('#lines'); if (!lines) return;

    const total = cart.total_price / 100;
    const ship = n === 0 ? 0 : (total >= FREE_AT ? 0 : SHIP);
    // Pack prices come from Shopify automatic discounts, so show them as "Pack savings"
    const disc = Math.max(0, (cart.original_total_price || 0) - (cart.total_price || 0));
    const dRow = $('#discountRow');
    if (dRow){ dRow.hidden = disc <= 0; $('#discount').textContent = '−' + cents(disc); }
    $('#subtotal').textContent = cents(cart.original_total_price || cart.items_subtotal_price || 0);
    $('#shipping').textContent = n === 0 ? '—' : (ship === 0 ? 'Free' : money(ship));
    $('#total').textContent = money(total + ship);
    $('#shipTrack').style.transform = 'scaleX(' + Math.min(total / FREE_AT, 1) + ')';
    $('#shipMsg').textContent = n === 0 ? 'Free shipping on orders of ' + money(FREE_AT) + ' or more.'
      : (total >= FREE_AT ? 'You get free shipping.' : 'Add ' + money(FREE_AT - total) + ' more for free shipping.');
    $('#drawerFoot').hidden = n === 0;
    $('#giftNoteWrap').hidden = n === 0;

    if (!n){
      lines.innerHTML = `<li class="empty"><p>Your bag is empty.</p><a class="btn ghost" href="/#shop" data-close>Shop Hera</a></li>`;
    } else {
      lines.innerHTML = cart.items.map(it => {
        const colorOpt = (it.options_with_values || []).find(o => /colou?r/i.test(o.name)) || (it.options_with_values || [])[0];
        const colorName = (it.properties && it.properties.Color) || (colorOpt && colorOpt.value) || it.variant_title || '';
        const c = byName(colorName);
        const title = 'Hera Alarm';
        return `<li class="line">
          <div class="line-thumb" aria-hidden="true">${pill(c)}</div>
          <div><p class="line-title">${title}</p><p class="line-colors">${esc(colorName)}</p>
            <div class="qty" role="group" aria-label="Quantity, ${esc(colorName)}">
              <button type="button" data-dec="${esc(it.key)}" data-q="${it.quantity}" aria-label="Remove one ${esc(colorName)} alarm">−</button><span>${it.quantity}</span><button type="button" data-inc="${esc(it.key)}" data-q="${it.quantity}" aria-label="Add one more ${esc(colorName)} alarm">+</button>
            </div></div>
          <div class="line-price"><span>${cents(it.final_line_price)}</span><button type="button" data-rm="${esc(it.key)}">Remove</button></div>
        </li>`;
      }).join('');
    }

    // Nudge toward the next pack price
    const up = $('#upsell');
    const first = cart.items && cart.items[0];
    if (n === 1 && first){
      up.innerHTML = `<div class="upsell"><p><b>Make it a pair.</b> Add a second alarm for ${money(BUNDLES[2].price - SINGLE)} more and get free shipping.</p><button class="link-arrow" type="button" data-more="${esc(first.key)}" data-q="${first.quantity}">Add a second alarm <span aria-hidden="true">→</span></button></div>`;
    } else if (n === 2 && first){
      up.innerHTML = `<div class="upsell"><p><b>One for her too?</b> A third alarm is ${money(BUNDLES[3].price - BUNDLES[2].price)} more with the 3-pack price.</p><button class="link-arrow" type="button" data-more="${esc(first.key)}" data-q="${first.quantity}">Add a third alarm <span aria-hidden="true">→</span></button></div>`;
    } else up.innerHTML = '';

    const gn = $('#giftNote');
    if (gn && document.activeElement !== gn) gn.value = cart.note || '';
  }

  document.addEventListener('click', e => {
    const t = e.target.closest('button, a'); if (!t) return;
    if (t.dataset.inc) changeLine(t.dataset.inc, +t.dataset.q + 1);
    else if (t.dataset.dec) changeLine(t.dataset.dec, +t.dataset.q - 1);
    else if (t.dataset.rm){ changeLine(t.dataset.rm, 0).then(() => toast('Removed from your bag.')); }
    else if (t.dataset.more) changeLine(t.dataset.more, +t.dataset.q + 1);
    else if (t.hasAttribute('data-close')) closeCart();
  });

  // Gift note becomes the Shopify order note
  const gn = $('#giftNote');
  if (gn){
    let noteTimer = null;
    gn.addEventListener('input', () => {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(() => cartPost('/cart/update.js', {note:gn.value}).catch(() => {}), 500);
    });
  }

  /* ---------- Drawer ---------- */
  const drawer = $('#drawer'), scrim = $('#scrim');
  let lastFocus = null;
  function openCart(){
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('open'); scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => $('#closeCart').focus(), 60);
  }
  function closeCart(){
    if (!drawer) return;
    drawer.classList.remove('open'); scrim.classList.remove('open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (drawer){
    $('#cartBtn').addEventListener('click', e => { e.preventDefault(); openCart(); });
    $('#closeCart').addEventListener('click', closeCart);
    scrim.addEventListener('click', closeCart);
    document.addEventListener('keydown', e => {
      if (!drawer.classList.contains('open')) return;
      if (e.key === 'Escape'){ closeCart(); return; }
      if (e.key === 'Tab'){
        const f = $$('button, a[href], input, textarea, summary', drawer).filter(el => !el.closest('[hidden]') && el.offsetParent !== null);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
      }
    });
    $('#checkout').addEventListener('click', () => {
      const b = $('#checkout'); b.disabled = true; b.textContent = 'Going to checkout…';
      location.href = '/checkout';
    });
  }

  /* ---------- Announcement pause ---------- */
  const mt = $('#marqueeToggle');
  if (mt) mt.addEventListener('click', () => {
    const paused = $('#announce').classList.toggle('paused');
    mt.setAttribute('aria-pressed', String(paused));
    mt.setAttribute('aria-label', paused ? 'Play scrolling announcement' : 'Pause scrolling announcement');
  });

  /* ---------- Header + menu ---------- */
  const header = $('#header');
  const menuBtn = $('#menuBtn'), nav = $('#nav');
  if (menuBtn){
    menuBtn.addEventListener('click', () => {
      const open = nav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', String(open));
      menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    nav.addEventListener('click', e => { if (e.target.closest('a')){ nav.classList.remove('open'); menuBtn.setAttribute('aria-expanded','false'); menuBtn.setAttribute('aria-label','Open menu'); } });
  }

  fetchCart(false);

  /* ========== STOREFRONT (only where the Hera section is on the page) ========== */
  if (!$('#buyForm')){
    addEventListener('scroll', () => header && header.classList.toggle('scrolled', scrollY > 8), {passive:true});
    return;
  }

  const REVIEWS = H.reviews || [];
  const FOUNDER = H.founder || {text:'', name:''};
  const state = {color:'pink', bundle:2, slots:['pink','pink','pink']};

  /* ---------- Product photos (one per color) ---------- */
  const PHOTO_ALT = {
    pink:'The Baby Pink Hera alarm held in a hand, showing the SOS button, frosted light and silver key ring',
    blue:'The Baby Blue Hera alarm on a keyring with house keys, held in a hand',
    white:'The Pearl White Hera alarm held in a hand, with the key ring hooked over a finger',
    black:'The Onyx Black Hera alarm held between thumb and fingers, showing the SOS button and frosted light'
  };
  const photoSrc = (c, w) => H.assetBase + 'hera-' + c + '-' + w + '.jpg';
  let photoTimer = null, shownPhoto = 'pink';
  function setPhoto(c){
    const img = $('#gPhoto');
    $('#photoTag').textContent = COLORS[c].name;
    $('#gThumbPhoto').src = photoSrc(c, 600);
    if (c === shownPhoto) return;
    shownPhoto = c;
    clearTimeout(photoTimer);
    img.classList.add('swap');
    photoTimer = setTimeout(() => {
      const done = () => img.classList.remove('swap');
      img.onload = done;
      img.srcset = photoSrc(c, 600) + ' 600w, ' + photoSrc(c, 1000) + ' 1000w';
      img.src = photoSrc(c, 1000);
      img.alt = PHOTO_ALT[c];
      if (img.complete) done();
    }, 180);
  }
  const warm = () => Object.keys(COLORS).forEach(c => { const i = new Image(); i.decoding = 'async'; i.srcset = photoSrc(c, 600) + ' 600w, ' + photoSrc(c, 1000) + ' 1000w'; i.sizes = '(max-width: 900px) 92vw, 620px'; i.src = photoSrc(c, 1000); });
  addEventListener('load', () => ('requestIdleCallback' in window ? requestIdleCallback(warm) : setTimeout(warm, 1200)));

  /* ---------- Color ---------- */
  let swapTimer = null;
  function setColor(c){
    if (!COLORS[c]) return;
    const changed = c !== state.color;
    state.color = c; state.slots[0] = c;
    const apply = () => {
      document.documentElement.dataset.color = c;
      $('#displayTag').textContent = COLORS[c].name;
    };
    clearTimeout(swapTimer);
    const dp = $('#displayPill');
    dp.classList.remove('in');
    if (changed){
      dp.classList.add('out');
      swapTimer = setTimeout(() => { apply(); dp.classList.remove('out'); void dp.offsetWidth; dp.classList.add('in'); }, 170);
    } else { apply(); dp.classList.remove('out'); }
    setPhoto(c);
    $('#colorName').textContent = COLORS[c].name;
    $('#heroShown').textContent = 'Shown in ' + COLORS[c].name;
    $$('.dot').forEach(d => d.setAttribute('aria-pressed', String(d.dataset.setColor === c)));
    const radio = $('#c-' + c); if (radio && !radio.checked) radio.checked = true;
    updateBuy();
  }
  $$('.dot').forEach(d => d.addEventListener('click', () => setColor(d.dataset.setColor)));
  $$('input[name="color"]').forEach(r => r.addEventListener('change', () => setColor(r.value)));

  /* ---------- Pack + per-alarm colors ---------- */
  function renderSlots(){
    const box = $('#slots'), rows = $('#slotRows');
    if (state.bundle === 1){ box.hidden = true; rows.innerHTML = ''; return; }
    box.hidden = false;
    let html = '';
    for (let i = 1; i < state.bundle; i++){
      const cur = state.slots[i];
      html += `<fieldset class="slot"><legend class="slot-name" style="margin:0">Alarm ${i+1}<em>${COLORS[cur].name}</em></legend><div class="swatches sm">` +
        Object.keys(COLORS).map(k => { const out = VARIANTS.length && !colorAvailable(k); return `<div class="swatch${out ? ' soldout' : ''}"><input type="radio" name="slot${i}" id="s${i}-${k}" value="${k}" ${k===cur?'checked':''} data-slot="${i}"><label for="s${i}-${k}" title="${COLORS[k].name}${out ? ' (sold out)' : ''}"><i style="--sw:${COLORS[k].sw}"></i><span class="sr-only">${COLORS[k].name} for alarm ${i+1}${out ? ', sold out' : ''}</span></label></div>`; }).join('') +
        `</div></fieldset>`;
    }
    rows.innerHTML = html;
    rows.style.display = 'grid'; rows.style.gap = '12px';
  }
  $('#slotRows').addEventListener('change', e => {
    const t = e.target; if (!t.dataset.slot) return;
    const i = +t.dataset.slot; state.slots[i] = t.value;
    const em = t.closest('fieldset').querySelector('em'); if (em) em.textContent = COLORS[t.value].name;
    updateBuy();
  });
  function setBundle(n){
    state.bundle = n;
    for (let i = 1; i < 3; i++) if (!state.slots[i]) state.slots[i] = state.color;
    const r = $('#b-' + n); if (r && !r.checked) r.checked = true;
    renderSlots(); updateBuy();
  }
  $$('input[name="bundle"]').forEach(r => r.addEventListener('change', () => setBundle(+r.value)));

  function currentColors(){ return state.slots.slice(0, state.bundle); }
  function updateBuy(){
    const b = BUNDLES[state.bundle];
    $('#price').textContent = money(b.price);
    $('#per').textContent = state.bundle === 1 ? 'Ships for ' + money(SHIP) : b.each + ' each · Free shipping';
    const save = $('#save');
    if (state.bundle > 1){ save.hidden = false; save.textContent = 'Save ' + money(SINGLE * state.bundle - b.price); } else save.hidden = true;
    const cols = currentColors();
    // Only offer "Add to bag" when Shopify can actually sell every chosen color
    const out = cols.filter(c => !colorAvailable(c));
    const addBtn = $('#addBtn'), stickyAdd = $('#stickyAdd');
    let note = $('#stockNote');
    if (!note){ note = document.createElement('p'); note.id = 'stockNote'; note.className = 'stock-note'; note.setAttribute('aria-live', 'polite'); addBtn.insertAdjacentElement('afterend', note); }
    let blocked = false;
    if (!VARIANTS.length){
      blocked = true; $('#addLabel').textContent = 'Coming soon';
      note.textContent = 'Hera launches soon. Sign up below to hear first.';
    } else if (out.length){
      blocked = true; $('#addLabel').textContent = 'Sold out';
      note.textContent = [...new Set(out)].map(c => COLORS[c].name).join(' and ') + (new Set(out).size > 1 ? ' are' : ' is') + ' sold out right now. Choose another color.';
    } else {
      $('#addLabel').textContent = 'Add to bag · ' + money(b.price);
      note.textContent = '';
    }
    note.hidden = !note.textContent;
    addBtn.disabled = blocked; stickyAdd.disabled = blocked;
    $('#stickyMeta').textContent = state.bundle > 1
      ? b.label + ' · ' + cols.map(c => SHORT[c]).join(' + ') + ' · ' + money(b.price)
      : COLORS[cols[0]].name + ' · ' + money(b.price);
    $('#stickyAdd').setAttribute('aria-label', 'Add ' + (state.bundle > 1 ? b.label + ', ' + cols.map(c => COLORS[c].name).join(', ') : COLORS[cols[0]].name + ' alarm') + ' to bag, ' + money(b.price));
  }

  /* ---------- Add to bag: a color dot flies into the bag ---------- */
  let doneTimer = null, adding = false;
  function flyToBag(from){
    const a = from.getBoundingClientRect(), b = $('#cartBtn').getBoundingClientRect();
    const dot = document.createElement('div');
    dot.className = 'fly c-' + state.color;
    dot.style.left = (a.left + a.width / 2 - 9) + 'px';
    dot.style.top = (a.top + a.height / 2 - 9) + 'px';
    document.body.appendChild(dot);
    const dx = (b.left + b.width / 2) - (a.left + a.width / 2), dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    const anim = dot.animate([
      {transform:'translate(0,0) scale(1)', opacity:1},
      {transform:`translate(${dx * .5}px, ${dy * .5 - 80}px) scale(1.15)`, opacity:1, offset:.45},
      {transform:`translate(${dx}px, ${dy}px) scale(.4)`, opacity:.2}
    ], {duration:620, easing:'cubic-bezier(.5,0,.4,1)'});
    return anim.finished.then(() => dot.remove(), () => dot.remove());
  }
  async function doAdd(e){
    if (adding || $('#addBtn').disabled) return;
    adding = true;
    const from = (e && e.currentTarget && e.currentTarget.id === 'stickyAdd') ? $('#stickyAdd') : $('#addBtn');
    const btn = $('#addBtn');
    btn.setAttribute('aria-busy', 'true');
    const colors = currentColors();
    const flight = (reduce || !from.animate) ? Promise.resolve() : flyToBag(from);
    const ok = await addToCart(colors);
    await flight;
    btn.removeAttribute('aria-busy');
    adding = false;
    if (!ok) return;
    btn.classList.add('done'); $('#addLabel').textContent = 'Added to your bag';
    clearTimeout(doneTimer);
    doneTimer = setTimeout(() => { btn.classList.remove('done'); updateBuy(); }, 1600);
    setTimeout(openCart, reduce ? 0 : 150);
  }
  $('#buyForm').addEventListener('submit', e => { e.preventDefault(); doAdd(); });
  $('#stickyAdd').addEventListener('click', doAdd);

  $('#giftBtn').addEventListener('click', () => {
    setBundle(2);
    if (state.slots[1] === state.color){
      const other = ['blue', 'pink', 'white', 'black'].find(c => c !== state.color && (colorAvailable(c) || !VARIANTS.length));
      if (other){ state.slots[1] = other; renderSlots(); updateBuy(); }
    }
    $('#shop').scrollIntoView({behavior: reduce ? 'auto' : 'smooth'});
  });

  /* ---------- Gallery: swipe, thumbnails, arrows ---------- */
  const track = $('#gTrack'), slides = $$('.g-slide', track);
  let slideIdx = 0, gLock = null;
  function goTo(i){
    i = Math.max(0, Math.min(slides.length - 1, i));
    clearTimeout(gLock); gLock = setTimeout(() => { gLock = null; }, 700);
    syncGallery(i);
    track.scrollTo({left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth'});
  }
  function syncGallery(force){
    if (typeof force !== 'number' && gLock) return;
    const i = typeof force === 'number' ? force : Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    if (i === slideIdx && track.dataset.ready) return;
    slideIdx = i; track.dataset.ready = '1';
    $$('.g-thumb').forEach(t => t.setAttribute('aria-current', String(+t.dataset.slide === i)));
    $('#gPrev').disabled = i === 0;
    $('#gNext').disabled = i === slides.length - 1;
    slides.forEach((s, k) => s.toggleAttribute('inert', k !== i));
    $('#gHint').innerHTML = i === 0
      ? 'Photo · <button type="button" class="g-link" data-slide="1">Preview the siren &amp; light</button>'
      : 'Illustration · <button type="button" class="g-link" data-slide="0">Back to the photo</button>';
  }
  track.addEventListener('scroll', syncGallery, {passive:true});
  $('#gallery').addEventListener('click', e => { const b = e.target.closest('[data-slide]'); if (b) goTo(+b.dataset.slide); });
  $('#gPrev').addEventListener('click', () => goTo(slideIdx - 1));
  $('#gNext').addEventListener('click', () => goTo(slideIdx + 1));
  track.addEventListener('keydown', e => {
    if (e.target !== track) return;
    if (e.key === 'ArrowRight'){ e.preventDefault(); goTo(slideIdx + 1); }
    if (e.key === 'ArrowLeft'){ e.preventDefault(); goTo(slideIdx - 1); }
  });
  addEventListener('resize', () => { track.scrollLeft = slideIdx * track.clientWidth; }, {passive:true});
  syncGallery();

  $$('.sp').forEach(b => b.addEventListener('click', () => {
    setColor(b.dataset.pick);
    goTo(0);
    $('#shop').scrollIntoView({behavior: reduce ? 'auto' : 'smooth'});
  }));

  /* ---------- Previews (visual only, no sound) ---------- */
  const display = $('#display'), pvS = $('#pvSiren'), pvL = $('#pvLight');
  let sirenTimer = null;
  pvS.addEventListener('click', () => {
    const on = !display.classList.contains('siren');
    display.classList.toggle('siren', on);
    pvS.setAttribute('aria-pressed', String(on));
    clearTimeout(sirenTimer);
    if (on) sirenTimer = setTimeout(() => { display.classList.remove('siren'); pvS.setAttribute('aria-pressed', 'false'); }, 6000);
  });
  const LIGHT_STEPS = ['off', 'steady', 'flashing'];
  let lightStep = 0;
  pvL.addEventListener('click', () => {
    lightStep = (lightStep + 1) % LIGHT_STEPS.length;
    const s = LIGHT_STEPS[lightStep];
    display.classList.toggle('light-on', s !== 'off');
    display.classList.toggle('flash', s === 'flashing');
    pvL.setAttribute('aria-pressed', String(s !== 'off'));
    $('#pvLightLabel').textContent = s === 'off' ? 'Light' : (s === 'steady' ? 'Light: steady' : 'Light: flashing');
  });

  let burstTimer = null;
  $('#sosTap').addEventListener('click', () => {
    const rings = $('#heroRings'), hp = $('#heroPill');
    rings.classList.remove('burst'); hp.classList.remove('pressed');
    void rings.offsetWidth;
    rings.classList.add('burst'); hp.classList.add('pressed');
    setTimeout(() => hp.classList.remove('pressed'), 160);
    clearTimeout(burstTimer);
    burstTimer = setTimeout(() => rings.classList.remove('burst'), 1500);
  });

  /* ---------- Reviews + founder note (render only real content) ---------- */
  if (REVIEWS.length >= 3){
    $('#reviewsGrid').innerHTML = REVIEWS.map(r => `<li class="review" data-reveal><span class="stars" aria-label="${r.stars || 5} out of 5 stars">${'★'.repeat(r.stars || 5)}</span><blockquote>${esc(r.text)}</blockquote><p>${esc(r.name)}${r.place ? ', ' + esc(r.place) : ''}</p></li>`).join('');
    $('#reviews').hidden = false;
  }
  if (FOUNDER.text){
    $('#founderText').textContent = '“' + FOUNDER.text + '”';
    $('#founderName').textContent = FOUNDER.name;
    $('#founder').hidden = false;
  }

  /* ---------- Sticky mobile bar ---------- */
  const sticky = $('#stickyBuy'), stickyBtn = $('#stickyAdd');
  let addVisible = true, pastHero = false;
  function syncSticky(){
    const show = !addVisible && pastHero;
    sticky.classList.toggle('show', show);
    sticky.setAttribute('aria-hidden', String(!show));
    stickyBtn.tabIndex = show ? 0 : -1;
  }
  let ticking = false;
  addEventListener('scroll', () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => {
      header.classList.toggle('scrolled', scrollY > 8);
      pastHero = scrollY > innerHeight * .8;
      syncSticky(); ticking = false;
    });
  }, {passive:true});

  if ('IntersectionObserver' in window){
    new IntersectionObserver(es => { addVisible = es[0].isIntersecting; syncSticky(); }).observe($('#addBtn'));
    $$('[data-stagger]').forEach(g => $$('[data-reveal]', g).forEach((el, i) => el.style.setProperty('--d', i)));
    const io = new IntersectionObserver(es => es.forEach(en => {
      if (!en.isIntersecting) return;
      en.target.classList.add('revealed');
      en.target.classList.remove('pending');
      io.unobserve(en.target);
    }), {rootMargin:'0px 0px -8% 0px'});
    $$('[data-reveal]').forEach(el => {
      if (el.getBoundingClientRect().top > innerHeight){ el.classList.add('pending'); io.observe(el); }
    });
    const sb = $('#sizeBlock');
    if (sb.getBoundingClientRect().top > innerHeight){
      sb.classList.add('dims-pending');
      const dio = new IntersectionObserver(es => { if (es[0].isIntersecting){ sb.classList.remove('dims-pending'); dio.disconnect(); } }, {threshold:.35});
      dio.observe(sb);
    }
    const sio = new IntersectionObserver(es => es.forEach(en => en.target.classList.toggle('in-view', en.isIntersecting)), {threshold:.3});
    $$('[data-inview]').forEach(el => sio.observe(el));
  } else { addVisible = false; }

  /* ---------- Newsletter (posts to Shopify; only blocks an invalid email) ---------- */
  const nf = $('#newsForm');
  if (nf) nf.addEventListener('submit', e => {
    const input = $('#email'), msg = $('#newsMsg');
    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
    if (ok) return;
    e.preventDefault();
    msg.classList.add('err');
    input.setAttribute('aria-invalid', 'true');
    msg.textContent = 'Enter an email address like name@example.com.';
    input.focus();
  });

  /* ---------- Init: mark sold-out colors, start on an available one ---------- */
  if (VARIANTS.length){
    Object.keys(COLORS).forEach(c => {
      if (colorAvailable(c)) return;
      const sw = $('#c-' + c); if (sw){ sw.parentElement.classList.add('soldout'); const sr = sw.parentElement.querySelector('.sr-only'); if (sr) sr.textContent += ', sold out'; }
      const dot = $('.dot[data-set-color="' + c + '"]'); if (dot){ dot.classList.add('soldout'); dot.setAttribute('aria-label', COLORS[c].name + ' (sold out)'); }
    });
  }
  const start = colorAvailable('pink') ? 'pink' : (Object.keys(COLORS).find(colorAvailable) || 'pink');
  state.slots = [start, start, start];
  setColor(start); setBundle(2);
})();
